import Reflux from 'reflux';

module.exports = Reflux.createActions(['pushView', 'popView', 'changeView']);
